import { createSharedStoreHook } from 'shared-store-hook'

export const useMenu = createSharedStoreHook({
    initialState: 'home'
})